import { Row } from 'app/design/primitives/box';
import { isAnyWhiteLabel } from 'app/utils/helpers';
import type { useDesktopLandingData } from '../use-desktop-landing-data';
import { SocialMediaCard, WriteToMayorCard } from './immature-neighbourhood';

export function NeighbourhoodSocialActions({
  neighbourhoodStatus,
}: Pick<ReturnType<typeof useDesktopLandingData>, 'neighbourhoodStatus'>) {
  if (!neighbourhoodStatus?.writeToMayor && !neighbourhoodStatus?.joinSocialMedia) return null;
  return (
    <Row gap="spacing.general.x4" alignItems="stretch">
      {neighbourhoodStatus.writeToMayor && !isAnyWhiteLabel() ? <WriteToMayorCard /> : null}
      {neighbourhoodStatus.joinSocialMedia ? <SocialMediaCard /> : null}
    </Row>
  );
}
